import { SupportCenterItem } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SupportCenter/SupportCenterItem/SupportCenterItem";

export { SupportCenterItem };
